<div class="modal-header">
    <button class="btn-close" (click)="bsModalRef.hide()">
        <span></span>
        <span></span>
    </button>
</div>
<div class="modal-body">
    <div class="container">
        <div class="row">
            <div class="col-xs-12">
                <div class="col-md-12">
                    <h2 class="product-family">{{product.familyName}}</h2>
                    <h1 class="product-name">{{product.name}}</h1>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-sm-12">
                <form class="form-horizontal">
                    <div class="col-xs-12">
                        <div class="form-group">
                            <div class="col-xs-12 col-sm-6 text-left" [ngClass]="{loading:!loadAvatar}">
                                <img class="img-product" [src]="product.avatar|absolutePath:'products'"
                                    (load)="loadAvatar=true" alt="{{product.name}} en livraison">
                            </div>
                            <div class="col-xs-12 col-sm-6">
                                <div class="product-infos" *ngIf="!ismenuproduct">
                                    <span class="price"
                                        *ngIf="product.sizes?.length>0 && product.size>=0">{{product.sizes[product.size].price*product.qty|number:'1.2-2'| helpycurrency}}</span>
                                    <ng-container *ngIf="product.sizes?.length>0 && product.size>=0 && product.sizes[product.size].size!='.'
                                                     && product.sizes[product.size].level!=0">
                                        <span class="sep"></span>
                                        <span class="nb">{{product.sizes[product.size].size}}</span>
                                        <span class="sep"></span>
                                    </ng-container>
                                </div>
                                <div class="product-quantity vcenter" *ngIf="!ismenuproduct">
                                    <b>Quantité :</b>
                                    <div class="quantity">
                                        <button (click)="incrQty()">+</button>
                                        <p>{{product.qty}}</p>
                                        <button (click)="decrQty()">-</button>
                                    </div>
                                </div>
                                <div class="product-comment">
                                    <label>Commentaire : </label>
                                    <textarea name="comment" [(ngModel)]="product.comment" rows="3"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row" *ngIf="loading">
            <div class="col-md-12">
                <div class="placeholder">
                    <div class="animated-background"></div>
                </div>
                <div class="placeholder2">
                    <ng-container *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]">
                        <div class="animated-background"></div>
                    </ng-container>
                </div>
            </div>
        </div>
        <ng-container *ngIf="!loading">
            <div class="row margin">
                <div class="col-xs-12">
                    <div class="all">
                        <div class="compositions">
                            <p class="unavailableIng" *ngIf="unavComp>0 || unavOpt>0 || unavSupp>0">
                                <i class="flaticon-exclamation "></i> : Ingrédient non disponible pour le moment
                            </p>
                            <ul class="ul-comp">
                                <li *ngIf="product.compositions?.length>0">
                                    <p>Compositions :</p>
                                    <div class="row">
                                        <div class="col-md-4" *ngFor="let comp of product.compositions;let i=index"
                                            id="wTooltipComp{{i}}">
                                            <onoffswitch [borderd]="false" [(ngModel)]="comp.checked"
                                                [label]="comp.label" [available]="comp.available" placement="bottom"
                                                containerClass="customClass">
                                            </onoffswitch>
                                        </div>
                                    </div>
                                </li>
                                <li *ngIf="product.maxNbrIngOptions>0">
                                    <p>
                                        <ng-container *ngIf="(product.optionIngredients|groupByCategory).length>1">
                                            Options</ng-container>
                                        <ng-container *ngIf="(product.optionIngredients|groupByCategory).length==1">
                                            {{(product.optionIngredients|groupByCategory)[0].category}}</ng-container>
                                        : {{product.maxNbrIngOptions}} max
                                    </p>
                                    <div class="text-gray">
                                        <div class="d-flex" style="margin: 0px 0px 10px 0px"
                                            *ngIf="product.obligatoryIngredient.length>0">
                                            <label>Obligatoire :</label>
                                            <label *ngFor="let ing of product.obligatoryIngredient">
                                                {{ing.category}} : {{ing.maxNbrIngOptions}} ingredient(s)
                                            </label>
                                        </div>
                                    </div>
                                    <ul style="margin-left: 30px;">
                                        <li *ngFor="let c of product.optionIngredients|groupByCategory;let i=index">
                                            <div>
                                                <p class="p-color"
                                                    *ngIf="(product.optionIngredients|groupByCategory).length>1">
                                                    {{c.category}} :</p>
                                                <div class="row">
                                                    <div class="col-md-4" *ngFor="let opt of c.elements;let i=index">
                                                        <onoffswitch [borderd]="false" (change)="changeOption(opt)"
                                                            [(ngModel)]="opt.checked" [label]="opt.label"
                                                            [disabled]="!opt.available || (optChecked==product.maxNbrIngOptions && !opt.checked)"
                                                            [available]="opt.available">
                                                        </onoffswitch>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </li>
                                <li *ngIf="product.hasSupp>0">
                                    <p>Supplement :</p>
                                    <ul style="margin-left: 30px;">
                                        <li *ngFor="let c of product.supplements|groupByCategory;let i=index">
                                            <div>
                                                <p class="p-color">{{c.category}} :</p>
                                                <div class="row">
                                                    <div class="col-md-4" *ngFor="let supp of c.elements;let i=index">
                                                        <onoffswitch [borderd]="false" [(ngModel)]="supp.checked"
                                                            label="{{supp.label}} ( {{supp.price | helpycurrency}} )"
                                                            [available]="supp.available">
                                                        </onoffswitch>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <button *ngIf="!product2.id && !ismenuproduct" class="add-to-cart btn pull-right"
                        (click)="addToBasket()">
                        <i class="flaticon-shopping"></i>
                        <span>Ajouter au panier</span>
                    </button>
                    <button *ngIf="product2.id && !ismenuproduct" class="add-to-cart btn pull-right"
                        (click)="addToBasket()">
                        <i class="flaticon-shopping"></i>
                        <span>Modifier</span>
                    </button>
                    <button *ngIf="ismenuproduct" class="add-to-cart btn pull-right" (click)="valider()">
                        <i class="flaticon-shopping"></i>
                        <span>Valider</span>
                    </button>
                </div>
            </div>
        </ng-container>
    </div>
</div>